import React from 'react';
import { Container, ContentContainer, InfoText } from './styles';
import { IoShapesOutline } from 'react-icons/io5';
import { LoadingComponent } from 'components/Loading';

interface IEmptyData {
  icon?: () => JSX.Element;
  noPadding?: boolean;
  small?: boolean;
  loading?: boolean;
}

export const EmptyData: React.FC<IEmptyData> = (props) => {
  const { children, icon: Icon, noPadding, small, loading } = { ...props };
  return (
    <ContentContainer noPadding={noPadding}>
      <Container>
        {!!loading ? (
          <LoadingComponent opacity="1" background="transparent" size={12} color="#6e6e6e" />
        ) : (
          <>
            {!!Icon ? <Icon /> : <IoShapesOutline />}
            <InfoText small={small}>{children}</InfoText>
          </>
        )}
      </Container>
    </ContentContainer>
  );
};
